
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import EmptyView from '@xt/www/components/gensee/EmptyView.vue'

@Observer
@Component({
  components: {
    HeaderImage,
    EmptyView
  }
})
export default class PlaybackPageView extends Vue {
  visibleQARecord = false

  get PageStore() {
    return this.$store.$genseePlayback
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  handleClickUnReadCount() {
    const el = document.getElementById('comment-scroll')

    if (el instanceof HTMLDivElement) {
      el.scrollTo(0, el.scrollHeight)
    }
  }

  created() {}
  mounted() {}
  destroyed() {}
}
